import apiHandler from "components/Defaults/ApiHandler";
import axios from "axios";
import { saveAs } from 'file-saver';

export const searchDocuments = (searchTerm, extension, authors, subjects, page, callback, errorCallback) => {
    const config = {
        url: '/api/document/search',
        method: "POST",
        data: { query: searchTerm, ext: extension, page: page, authors: authors, subjects: subjects },
    }
    apiHandler("Searching...", config, async config => {
        const response = await axios.request(config);
        callback && callback(response.data)
    }, errorCallback)
}

export const getFilters = (callback, errorCallback) => {
    const config = {
        url: '/api/document/get_filters'
    }
    apiHandler("Getting filters", config, async config => {
        const response = await axios.request(config);
        callback && callback(response.data)
    }, errorCallback)
}

export const downloadDocument = (id, callback, errorCallback) => {
    const config = {
        url: `/api/document/${id}/download`,
        method: 'GET',
        responseType: 'blob' // ← tells Axios to expect binary data
    };
    apiHandler("Download document", config, async config => {
        const response = await axios.request(config);
        const blob = new Blob([response.data], { type: response.headers['content-type'] });
        const fileName = response.headers['content-disposition']?.match(/filename="(.+)"/)?.[1] || 'downloadedFile';
    
        saveAs(blob, fileName);
        callback && callback();
    }, errorCallback);
}

export const getDocument = (id, callback, errorCallback) => {
    const config = {
        url: `/api/document/${id}/download`
    }
    apiHandler("Download document", config, async config => {
        const response = await axios.request(config);
        console.log(response)
        console.log(response.data)
        console.log(response.extension)
        console.log(response.data?.data)
        console.log(response.data?.extension)
        if (response.data) {
            let binaryString = window.atob(response.data?.data);
            let arrayBuffer = new ArrayBuffer(binaryString.length);
            let byteArray = new Uint8Array(arrayBuffer);
            for (let i = 0; i < binaryString.length; i++) {
                byteArray[i] = binaryString.charCodeAt(i);
            }

            let result = null
            if (response.data.extension === 'pdf') {
                result = byteArray
            } else if (response.data.extension === 'epub') {
                const blob = new Blob([byteArray], {type: 'application/epub+zip'});
                blob.name = response?.data?.name
                result = blob
            } else if (response.data.extension === 'mobi') {
                const blob = new Blob([byteArray], {type: 'application/mobi'});
                blob.name = response?.data?.name
                result = blob
            }
            console.log(result)
            callback && callback({file: result, extension: response.data.extension})
        }
    }, errorCallback)
}

export const sendDocument = (document, email, callback, errorCallback) => {
    const config = {
        url: `/api/document/${document.id}/send/${email}`,
        method: "GET",
    }
    apiHandler("Sending...", config, async config => {
        const response = await axios.request(config);
        callback && callback(response.data)
    }, errorCallback)
}

export const getEmails = (callback, errorCallback) => {
    const config = {
        url: `/api/user/emails`,
        method: "GET",
    }
    apiHandler("Loading...", config, async config => {
        const response = await axios.request(config);
        callback && callback(response.data)
    }, errorCallback)
}

export const uploadFile = (file, progressCallback, callback, errorCallback) => {
    const formData = new FormData();
    formData.append("files", file);
  
    const config = {
      url: "/api/custom-document/upload",
      method: "POST",
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data",
      },
      // Pass the upload progress events to the provided callback
      onUploadProgress: progressCallback,
    };
  
    apiHandler("Uploading...", config, async (config) => {
      const response = await axios.request(config);
      callback && callback(response.data);
    }, errorCallback);
  };

export const getCustomDocuments = (callback, errorCallback) => {
    const config = {
        url: `/api/custom-document`,
        method: "GET",
    }
    apiHandler("Loading...", config, async config => {
        const response = await axios.request(config);
        callback && callback(response.data)
    }, errorCallback)
}